import { render, staticRenderFns } from "./CmgOverlay.vue?vue&type=template&id=737d3d64&scoped=true&lang=pug"
import script from "./cmg-overlay.ts?vue&type=script&lang=ts&external"
export * from "./cmg-overlay.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgOverlay.vue?vue&type=style&index=0&id=737d3d64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737d3d64",
  null
  
)

export default component.exports